import moment from 'moment';
import { Text, View, Image, TouchableOpacity } from 'react-native';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { tdsActions } from './tdsRedux/tds.actions';
import { backgroundTdsArr, backgroundTdsArrMainPage } from './backgroundTdsArr';
import { navigateAction, replaceAction } from '../../helpers/navigationHelpers';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import {
  Container,
  ButtonWrapper,
  RowContainer,
  Section,
  FormText,
  Heading,
  SubHeading,
  ActivateButtonWrapper,
  primaryColor,
  Typography,
} from './style';
import { tdsLocationSelected } from '../../redux/actions/app';
import getPlatformType from '../../helpers/getPlatform';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { useTheme } from '@emotion/react';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { buttonPressEvent } from '../../helpers/analytics';

const tdsLocation = (props) => {
  const { navigation } = props;
  const layoutType = getPlatformType();
  const dispatch = useDispatch();
  const [type, setType] = useState('web');
  const { colors } = useTheme();
  const [showError, setShowError] = useState(false);
  const [state, setState] = useState({ deposit_start_date: null });
  const searchDepositResponse = useSelector((state) => state.tds?.searchedDeposit);

  const handleChange = (value, field) => {
    setState({ ...state, [field]: value });
  };





  const renderInfoBox = (type, text, routes) => {
    return (
      // <View
      //   style={{
      //     width: 310,
      //     backgroundColor:  '#e6efff' ,
      //     justifyContent: 'center',
      //     alignItems: 'center',
      //     paddingVertical: 50,
      //     borderRadius: 10,
      //     margin:10,
      //     borderWidth:1,
      //     borderColor:"#194592"
      //   }}
      //   id={'TDS-INFO-BOX'}
      // >
      //   <Text
      //     style={{
      //       color: "#194592",
      //       fontSize: 23,
      //       fontWeight: '600',
      //     }}
      //   >
      //     {' '}
      //     {text ? text : ''}
      //   </Text>
      // <ButtonWrapper
      // onPress={()=>{
      //   navigateAction(navigation, routes);
      //   dispatch(tdsLocationSelected(routes))
      // }}
      //     id={'TDS-GO-BACK'}
      //     width={"80%"}
      //     color={"white"}
      //   >
      //     <Text style={{ color: '#194592',fontWeight:"700" }}>SELECT</Text>
      //   </ButtonWrapper>
      // </View>
      <ODSButton
        restStyle={{ width: 266, backgroundColor: routes == "TdsScoctland" ? '#009DFA' : '#001A96' }}
        txtSize={22}
        onPress={() => {
          navigateAction(navigation, routes);
          dispatch(tdsLocationSelected(type?type: routes))
          buttonPressEvent("TDS Deposit " + text, type?type: "TDS");
        }}
      >
        {text ? text : ''}
      </ODSButton>
    );
  };


  const renderLocationDeposit = () => {
    return (
      <View style={{ alignItems: 'center' }}>
        <ODSText type='h3' color={'#FFFFFF'} textAlign='center'>View & Manage your tenancy deposit</ODSText>
        <RowContainer style={{
          display: 'flex',
          width: layoutType == "phone" ? '90%' : 790,
          padding: 40,
          flexDirection: 'column',
          alignItems: 'center',
          borderRadius: 16,
          backgroundColor: '#FFF',
          shadowColor: 'rgba(0, 0, 0, 0.15)',
          shadowOffset: { width: 0, height: 13 },
          shadowRadius: 13,
          shadowOpacity: 1,
          marginTop: 60
        }}>
          <ODSText type='h6' fontWeight={'400'} color={colors.text.primaryColor} textAlign='center'>
            Please select where your deposit is located
          </ODSText>
          <View style={layoutType == "phone" ? { flexDirection: "column", alignItems: 'center', gap: 20, marginTop: 48 } : { justifyContent: 'center', flexDirection: "row", flexWrap: 'wrap', marginTop: 48, gap: 20 }}>
            {renderInfoBox(null, 'England or Wales', "TDS Search Deposit")}
            {renderInfoBox(null, 'Scotland', "TdsScoctland")}
            {renderInfoBox('TDS_NI', 'Northern Ireland', "TDS Search Deposit")}
          </View>
        </RowContainer>
      </View>
    );
  };

  return (
    <>
      <BackGroundGenerator
        replace={'Dashboard'}
        isBack={true}
        backNavigation={() => replaceAction(navigation, 'Dashboard')}
        isTds
        props={props}
        infoIcon

        paddingtop={50}
        layoutType={(data) => {
          setType(data);
        }}
        isTLYF
        hideMiddleLogo={true}
        backgroundArr={backgroundTdsArrMainPage}
      >
        <View style={{ marginTop:70,marginBottom:50 }}>{renderLocationDeposit()}</View>
      </BackGroundGenerator>
    </>
  );
};

export default tdsLocation;
